"use strict";

var _toConsumableArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/toConsumableArray.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createRules;
var _html = _interopRequireDefault(require("./html"));
var _gdocs = _interopRequireDefault(require("./gdocs"));
var _word = _interopRequireDefault(require("./word"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function createRules(blockContentType) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return [].concat(_toConsumableArray((0, _word.default)(blockContentType, options)), _toConsumableArray((0, _gdocs.default)(blockContentType, options)), _toConsumableArray((0, _html.default)(blockContentType, options)));
}